import { useMutation } from "@tanstack/react-query";
import { bulkFillAndBookActivities, BulkFillAndBookActivitiesPayload } from "PFCore/services/activities";
import { Id, MutationOptions } from "PFTypes";

export const useActivityBulkFillAndBook = (
  options: MutationOptions<BulkFillAndBookActivitiesPayload, { id: Id }> = {}
) =>
  useMutation<{ id: Id }, unknown, BulkFillAndBookActivitiesPayload>({
    mutationFn: bulkFillAndBookActivities,
    ...options
  });
